export const LIST_ALL = "/v1/appointment/customer/list/all";

export const CUSTOMER_HISTORY_URL = "/v1/appointment/customer/list/history";